/** Resume AudioContext after a user gesture (browser autoplay policy). */

export async function ensureAudioContextRunning(context: AudioContext): Promise<AudioContext> {
  if (context.state === "suspended") {
    await context.resume();
  }
  return context;
}

export function createAudioContext(options?: AudioContextOptions): AudioContext {
  const Ctor = globalThis.AudioContext ?? (globalThis as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) {
    throw new Error("Web Audio API is unavailable in this environment");
  }
  return new Ctor(options);
}

/**
 * Call from a click/keydown handler before starting sound.
 * Safe to call multiple times.
 */
export async function resumeAudioOnGesture(context: AudioContext): Promise<void> {
  await ensureAudioContextRunning(context);
}
